import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import SideNav from 'modules/navigation/web/sideNav.component';
import { withRouter } from 'react-router-dom';
import { layout } from 'app/styles';
import { View, Row } from 'modules/styled';
import BannerPrompt from 'modules/bannerPrompt/banner.container';
import SplashComponent from 'modules/navigation/banner';
import { slide as Menu } from 'react-burger-menu';
import {
  openWebSideNav,
  closeWebSideNav,
  hideModal,
} from 'modules/navigation/navigation.actions';
import { bindActionCreators } from 'redux';
import { getCommunities } from 'modules/community/community.actions';

class WithSideNav extends Component {
  static propTypes = {
    route: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    notif: PropTypes.object,
    actions: PropTypes.object,
    communities: PropTypes.array,
    sideNavIsOpen: PropTypes.bool,
    screenSize: PropTypes.number,
  };

  isMenuOpen = (state) => {
    if (state.isOpen) {
      this.props.actions.openWebSideNav();
    } else {
      this.props.actions.closeWebSideNav();
    }
    return state.isOpen;
  };

  static fetchData(dispatch) {
    return dispatch(getCommunities());
  }

  componentDidMount() {
    const { actions, communities } = this.props;
    if (!communities.length) actions.getCommunities();
  }

  render() {
    const { isAuthenticated, sideNavIsOpen, screenSize, notif, route } = this.props;
    const { promptType } = notif;
    const isDesktop = screenSize === 0;

    return (
      <View sx={{ bg: 'white' }}>
        {!isAuthenticated ? (
          <SplashComponent screenSize={screenSize} type={'app'} cta="SIGN_UP" />
        ) : null}
        {promptType ? (
          <View
            webContainerSx={{
              position: 'sticky',
              top: 0,
              zIndex: 200,
            }}
            style={{
              position: 'sticky',
            }}
            sx={{
              flexDirection: 'column',
              zIndex: 200,
              top: 0,
              right: 0,
              left: 0,
              minHeight: layout.BANNER_PROMPT_HEIGHT,
            }}
          >
            <BannerPrompt />
          </View>
        ) : null}
        <Row>
          {!isDesktop ? (
            <Menu
              width={layout.sideNavWidth}
              isOpen={sideNavIsOpen}
              onStateChange={this.isMenuOpen}
            >
              <View sx={{ top: promptType ? layout.BANNER_PROMPT_HEIGHT : 0 }}>
                <SideNav key={'mobile'} />
              </View>
            </Menu>
          ) : (
            <View>
              <SideNav key={'desktop'} />
            </View>
          )}
          <View sx={{ flex: 1 }}>{renderRoutes(route.routes)}</View>
        </Row>
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  communities: state.community.list,
  isAuthenticated: state.auth.isAuthenticated,
  navigation: state.navigation,
  sideNavIsOpen: state.navigation.sideNavIsOpen,
  screenSize: state.navigation.screenSize,
  notif: state.notif,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openWebSideNav,
      closeWebSideNav,
      hideModal,
      getCommunities,
    },
    dispatch
  ),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WithSideNav));
